import { gql } from "@apollo/client";

export const CREATE_USER_V2 = gql`
  mutation CreateUserV2($user: CreateUserInput!) {
    createUserV2(user: $user) {
      user {
        _id
        name
        email
        role
      }
    }
  }
`;
